<div class="content">
  <div class="container-fluid">
    <div class="page-title">
      <h1>
        <a href="javascript:void(0);" (click)="goBack()" class="back">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
        </a>
        {{'Group Status' | translate}}</h1>
    </div>
    <div class="index-content">
      <!-- Detail -->
      <div class="content-detail group-content {{groupParam.status}}">
        <div class="groupIcon">
          <i class="fa fa-sitemap" aria-hidden="true"></i>
        </div>
        <div class="detail-info clearfix">
          <div class="device-name">
            <div class="device-title">
              <i class="fa {{groupParam.icon}}" aria-hidden="true"></i>
              <h5>{{groupParam.gName}}</h5>
            </div>
            <div class="device-detail-info">
              {{groupParam.desc}}
            </div>
          </div>
          <div class="button float-right">
            <p-button icon="fa fa-cog" *ngIf="!groupParam.is_shared" (click)="display=true;"></p-button>
          </div>
        </div>
      </div>
      <!-- Current Status -->
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
          <div class="content-info">
            <div class="content-title">
              <h5 translate>Profile</h5>
            </div>
            <div class="content-body">
              <ul class="info-list">
                <li>
                  <div translate class="title">Description</div>
                  <div class="value">
                    <span [hidden]="groupParam.Description !== undefined">--</span>
                    <span [hidden]="groupParam.Description === undefined">{{groupParam?.Description}}</span>
                  </div>
                </li>
                <li>
                  <div translate class="title">Time Zone</div>
                  <div class="value">
                    <span [hidden]="groupParam.TimeZone !== undefined">--</span>
                    <span [hidden]="groupParam.TimeZone === undefined">{{groupParam?.TimeZone | utcFormat}}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
          <div class="content-info">
            <div class="content-title">
              <h5 translate>Device List</h5>
            </div>
            <div class="content-body">
              <!-- <p-dataTable [value]="groupParam.devices" class="group_deviceList">
                <p-column field="icon" header="" [style]="{'width':'30px'}" styleClass="col-nowrap">
                  <ng-template let-col let-item="rowData" pTemplate="body">
                    <i class="fa {{item.icon}} {{item.status}}" aria-hidden="true"></i>
                  </ng-template>
                </p-column>
                <p-column field="name" header="">
                  <ng-template let-col let-data="rowData" pTemplate="body">
                    <a [routerLink]="data.routeLink">{{data.name}}</a>
                  </ng-template>
                </p-column>
              </p-dataTable> -->
              <p-table [value]="groupParam.All_devices" class="group_deviceList">
                <ng-template pTemplate="body" let-item>
                  <tr [class.disabled]="item.isExpired ? true : companionAlert ? (item.protecting ? (item.status !== 'offline' ? true : null) : null) : null" [ngClass]="{'trial_block': item.isExpired && item.canTrial, 'companion_block': !item.isExpired && companionAlert && item.protecting && item.status !== 'offline'}">
                    <td style="width:30px;"><i class="fa {{item.icon}} {{item.status}}" aria-hidden="true"></i></td>
                    <td>
                      <div class="flex between">
                        <a [routerLink]="item.routeLink" [class.disabled]="item.isExpired ? true : companionAlert ? (item.protecting ? (item.status !== 'offline' ? true : null) : null) : null">
                          {{item.name}} <span *ngIf="item.is_shared" class="badge badge-primary">Shared</span>
                        </a>
                        <div class="button" *ngIf="item.isExpired">
                          <button type="button" pButton (click)="displayisTrialDialog(item);" label="{{'Get Free Trial' | translate}}"
                          class="p-button-rounded" icon="fa fa-lock" *ngIf="item.canTrial"></button>
                          <button type="button" pButton (click)="displayExpiredDialog(item);" label="{{'Locked' | translate}}"
                          class="p-button-rounded p-button-secondary" icon="fa fa-lock" *ngIf="!item.canTrial"></button>
                        </div>
                        <div class="button" *ngIf="!item.isExpired">
                          <button type="button" pButton (click)="routerCompanion();" label="{{'See Companion' | translate}}"
                          class="p-button-rounded ui-button-danger" *ngIf="!powerMaster && companionAlert && item.protecting && item.status !== 'offline'"></button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <div translate class="ui-emptymessage">No Device found</div>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </div>
      <!-- Energy Reporting -->
      <div *ngIf="energyInfoFeature" class="content-info">
        <div class="content-title">
          <h5 translate>Energy Reporting</h5>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="content-body statistic">
              <h6 translate>Statistic</h6>
              <ul class="info-list">
                <li class="date">
                  <div class="range">
                    <span class="dateLabel">From</span>
                    <p-datepicker [(ngModel)]="energyRangeStart" [showIcon]="true" dateFormat="yy/mm/dd"></p-datepicker>
                  </div>
                  <div class="range">
                    <span class="dateLabel toLabel" translate>to</span>
                    <p-datepicker [(ngModel)]="energyRangeEnd" [showIcon]="true" dateFormat="yy/mm/dd"></p-datepicker>
                  </div>
                </li>
                <li>
                  <div class="title" translate>Average Energy Consumption</div>
                  <div class="value"> {{'Wh' | translate}}</div>
                </li>
                <li>
                  <div class="title" translate>Cumulative Energy Consumption</div>
                  <div class="value"> {{'Wh' | translate}}</div>
                </li>
                <li>
                  <div class="title" translate>Cumulative Cost</div>
                  <div class="value"></div>
                </li>
                <li>
                  <div class="title">CO<span class="small">2</span> </div>
                  <div class="value"> {{'Kg' | translate}}</div>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="content-body settings">
              <h6 translate>Settings</h6>
              <ul class="info-list">
                <li>
                  <div class="title">{{'Country' | translate}} </div>
                  <div class="value">{{groupParam?.Country}}</div>
                </li>
                <li>
                  <div class="title" translate>Cost per kWh</div>
                  <div class="value">{{groupParam?.CostSetting}}</div>
                </li>
                <li>
                  <div class="title">CO<span class="small">2</span> {{'Emitted per kWh' | translate}}</div>
                  <div class="value">{{groupParam?.CO2Emitted}}</div>
                </li>
                <li>
                  <div class="title">CO<span class="small">2</span> {{'Unit of Measurement' | translate}}</div>
                  <div class="value">{{groupParam?.CO2Measure}}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- Event Logs -->
      <div class="content-info evnets">
        <div class="content-title-table border-b-radius-none">
          <h5 translate>Event Logs</h5>
        </div>
        <!-- <p-dataTable [value]="eventLogs$ | async" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,20]">
          <p-column [sortable]="true" field="icon" header="Status" styleClass="text-center col-nowrap"
                    [style]="{'width':'100px'}">
            <ng-template let-col let-data="rowData" pTemplate="body">
              <span class="center" *ngIf="!data.isHardwareFault">
                <i class="fa {{data.icon}} {{data.status}}" aria-hidden="true"></i>
              </span>
              <div class="icon errorCodeIcon" [ngStyle]="{'background-color': data.faultLevelColor}" *ngIf="data.isHardwareFault">
                <span>H</span>
              </div>
            </ng-template>
          </p-column>
          <p-column [sortable]="true" field="time" header="Time" [style]="{'width':'170px'}" styleClass="col-nowrap">
            <ng-template let-col let-item="rowData" pTemplate="body">
              {{(item.time != null) ? ((item.timestamp * 1000) + ((localTimeZone + item.timeZone)* 60 * 60 * 1000) | date: 'yyyy/MM/dd HH:mm:ss') : ''}}
            </ng-template>
          </p-column>
          <p-column [sortable]="true" field="timezoneLabel" header="Time Zone" [style]="{'width':'120px'}"
                    styleClass="hidden-sm"></p-column>
          <p-column [sortable]="true" field="name" header="Device Name" [style]="{'width':'200px'}"
                    styleClass="col-nowrap ellipsis">
            <ng-template let-col let-data="rowData" pTemplate="body">
              <a [routerLink]="data.routeLink">{{data.name}}</a>
            </ng-template>
          </p-column>
          <p-column [sortable]="true" field="desc" header="Status Description" [style]="{'width':'100%'}"
                    styleClass="desc"></p-column>
        </p-dataTable> -->
        <div class="border-t-radius-none">
          <p-table class="deviceTable" #dt [columns]="eventLogs_cols" [value]="eventLogs$ | async" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,20]"
            [scrollable]="true">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
                  {{col.header | translate}}
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr>
                <td style="width: 100px" class="col-nowrap text-center">
                  <span class="center" *ngIf="!rowData.isHardwareFault">
                    <i class="fa {{rowData.icon}} {{rowData.status}}" aria-hidden="true"></i>
                  </span>
                  <div class="icon errorCodeIcon" *ngIf="rowData.isHardwareFault">
                    <!-- <span>H</span> -->
                    <i class="fa fa-exclamation-triangle" aria-hidden="true" [ngStyle]="{'color': rowData.faultLevelColor}"></i>
                  </div>
                </td>
                <td style="width: 180px" class="col-nowrap">
                  {{rowData.time}}
                </td>
                <td style="width: 120px" class="hidden-sm">{{rowData.timezoneLabel}}</td>
                <td style="width: 200px" class="col-nowrap ellipsis">
                  <a [routerLink]="rowData.routeLink">{{rowData.name}}</a>
                </td>
                <td style="width: 100%" class="desc">{{rowData.desc}}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="eventLogs_cols.length">
                  <div translate class="ui-emptymessage">No Event found</div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="{{'Group Settings' | translate}}" [(visible)]="display" [modal]="true" [style]="{'width': '450px', 'min-width': '200px', 'top': '70px'}"
  [baseZIndex]="10000" class="settingsDialog">
  <p-tabs class="settings_tabView" (valueChange)="onTabChange($event)" [ngClass]="{'hideHeader': energyInfoFeature === false }" value="0">
    <p-tablist>
        <p-tab value="0">{{'Group Settings' | translate}}</p-tab>
        <p-tab value="1" *ngIf="energyInfoFeature">{{'Energy Cost Settings' | translate}}</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <div class="dialog-content">
          <div class="form-group">
            <label translate>Description</label>
            <input type="text" size="30" class="form-control pInputText" pInputText [(ngModel)]="groupParam.Description">
          </div>
          <div class="form-group">
            <label translate>Time Zone</label>
            <div class="select">
              <p-select [options]="timezoneOptions" [(ngModel)]="groupParam.TimeZone" appendTo="body"></p-select>
            </div>
          </div>
          <div translate class="alert alert-warning">
            Notices !!! The time zone of selected devices will be set as same with Group's time zone.
          </div>
        </div>
      </p-tabpanel>
      <p-tabpanel *ngIf="energyInfoFeature" value="1">
        <div class="dialog-content">
          <div class="form-group">
            <label translate>Country</label>
            <div class="select">
              <p-select [options]="unitOptions"></p-select>
            </div>
          </div>
          <div class="form-group">
            <label>Cost per kWh</label>
            <div class="select">
              <input type="text" size="30" class="form-control pInputText" pInputText>
            </div>
          </div>
          <div class="form-group">
            <label>CO<span class="small">2</span> Emitted per kWh</label>
            <div class="select">
              <input type="text" size="30" class="form-control pInputText" pInputText>
            </div>
          </div>
          <div class="form-group">
            <label>CO<span class="small">2</span> Measure Unit</label>
            <div class="select">
              <p-select [options]="unitOptions" appendTo="body"></p-select>
            </div>
          </div>
        </div>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
  <ng-template #footer>
    <button type="button" pButton label="{{'Save' | translate}}" (click)="profileSave()" class="{{Confirm_button}}"
      [hidden]="indexNum == 1"></button>
    <button type="button" pButton label="{{'Save' | translate}}" class="{{Confirm_button}}" [hidden]="indexNum == 0"></button>
    <button type="button" pButton (click)="display=false;resetField();" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>
<p-toast [style]="{marginTop: '70px'}"></p-toast>
<app-dialog></app-dialog>
